import { Component } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { Menu, MenuItem, ProSidebar, SubMenu } from "react-pro-sidebar"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { toggleAdmin } from "../../../../store/user/actions"
import { shouldAllowAccess } from "../../../../utilities/helper"
import MsalAuth from "../../../../utilities/msalAuth"
import UserSettings from "../../../../utilities/UserSettings"
import AccessControl from "../../../common/AccessControl"
import "react-pro-sidebar/dist/css/styles.css"
import "./SM2.css"
import { startActionableRequestsPoller } from "src/store/LeaseApprovals/actions"

interface SM2Props {
	toggleAdmin: typeof toggleAdmin
	features: { [key: string]: boolean }
	actionableRequestCount: number
	startActionableRequestsPoller: () => () => void
}

type SM2Types = {
	collapsed: boolean
	screenWidth: number
}

class SM2 extends Component<SM2Props, SM2Types> {
	userSettings: any = null
	stopPoller: (() => void) | null = null
	hasSettingsAccess = [
		shouldAllowAccess("CSS"),
		shouldAllowAccess("CSS:ADMIN"),
		shouldAllowAccess("FLEET:USER"),
		shouldAllowAccess("HR:ADMIN"),
	]

	state = {
		collapsed: false,
		screenWidth: 0,
	}

	componentDidMount() {
		this.updateWindowDimensions()
		window.addEventListener("resize", this.updateWindowDimensions)
		this.userSettings = MsalAuth.UserSettings()
		if (this.userSettings?.menuCollapsed) {
			this.setState({ collapsed: true })
		} else {
			this.setState({ collapsed: false })
			this.userSettings = {}
		}
		this.startPollerIfAllowed()
	}

	componentDidUpdate() {
		this.startPollerIfAllowed()
	}

	startPollerIfAllowed = () => {
		if (this.stopPoller) return
		if (!shouldAllowAccess("FLEET:LEASEADMIN")) return
		if (!this.props.features?.LeaseTracker) return
		this.stopPoller = this.props.startActionableRequestsPoller()
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateWindowDimensions)
		this.stopPoller?.()
	}

	updateWindowDimensions = () => {
		const temp = this.state
		if (!this.state.collapsed && window.innerWidth <= 1440) {
			temp.collapsed = true
		} else if (
			this.state.collapsed &&
			!this.userSettings.menuCollapsed &&
			window.innerWidth > 1440
		) {
			temp.collapsed = false
		}
		temp.screenWidth = window.innerWidth
		this.setState(temp)
	}

	toggleCollapsed = () => {
		if (this.state.collapsed) {
			this.setState({ collapsed: false })
			this.userSettings.menuCollapsed = false
		} else {
			this.setState({ collapsed: true })
			this.userSettings.menuCollapsed = true
		}
		// MsalAuth.updateUserSettings(this.userSettings)
		UserSettings.update(this.userSettings)
	}

	shouldShowSettings = () => {
		const hasSettingsAccess = this.hasSettingsAccess
		for (let i = 0; i < hasSettingsAccess.length; i++) {
			if (hasSettingsAccess[i]) {
				return true
			}
		}
		return
	}

	render() {
		const sm2Tooltip = (text: string) => {
			return (
				<Tooltip id="sm-tool-tip" style={{ margin: 0 }}>
					{text}
				</Tooltip>
			)
		}

		const actionableRequestCount = this.props.actionableRequestCount
		const showActionableBadge =
			actionableRequestCount > 0 &&
			shouldAllowAccess("FLEET:LEASEADMIN") &&
			!!this.props.features?.LeaseTracker
		const actionablePendingClass = showActionableBadge
			? "sm2-has-pending"
			: undefined

		return (
			<div className="SM2" id="sm2">
				<ProSidebar
					width={270}
					collapsedWidth={65}
					collapsed={this.state.collapsed}
				>
					<Menu iconShape="round">
						{/*****************************************My Portal********************************************************/}
						{shouldAllowAccess("MYPORTAL") && (
							<SubMenu
								title="My Portal"
								icon={<span className="material-icons">person</span>}
							>
								<AccessControl
									target="MYPORTAL:TIMESHEET"
									renderNoAccess={null}
								>
									<MenuItem
										icon={<span className="material-icons">date_range</span>}
									>
										Timesheet
										<Link to="/my-portal/timesheet" />
									</MenuItem>
								</AccessControl>
								<MenuItem
									icon={<span className="material-icons">notifications</span>}
								>
									Notifications
									<Link to="/notifications" />
								</MenuItem>
								<AccessControl target="MYPORTAL:PTO" renderNoAccess={null}>
									<MenuItem
										icon={<span className="material-icons">access_time</span>}
									>
										PTO
										<Link to="/my-portal/my-pto" />
									</MenuItem>
								</AccessControl>
								<MenuItem
									icon={<span className="material-icons">edit_calendar</span>}
								>
									Calendar
									<Link to="/my-portal/calendar" />
								</MenuItem>
								<MenuItem icon={<span className="material-icons">task</span>}>
									My Tasks
									<Link to="/my-portal/my-tasks" />
								</MenuItem>
								<AccessControl target="MYPORTAL:DELEGATE" renderNoAccess={null}>
									<MenuItem
										icon={
											<span className="material-icons">assignment_ind</span>
										}
									>
										Delegation
										<Link to="/my-portal/delegation" />
									</MenuItem>
								</AccessControl>
							</SubMenu>
						)}
						{/*****************************************HR***************************************************************/}
						{shouldAllowAccess("HR") && (
							<SubMenu
								title="Human Resources"
								icon={<span className="material-icons">people</span>}
							>
								<AccessControl
									target="PORTAL:EMPLOYEE-LIST-VIEWER"
									renderNoAccess={null}
								>
									<MenuItem
										icon={<span className="material-icons">people</span>}
									>
										Employees
										<Link to="/hr/employees" />
									</MenuItem>
								</AccessControl>
								<AccessControl target="HR:ELEV" renderNoAccess={null}>
									<MenuItem icon={<span className="material-icons">lock</span>}>
										Permissions
										<Link to="/hr/admin/permissions" />
									</MenuItem>
								</AccessControl>
								<AccessControl target={"HR:PTO"} renderNoAccess={null}>
									<MenuItem
										icon={<span className="material-icons">access_time</span>}
									>
										PTO
										<Link to="/hr/pto" />
									</MenuItem>
								</AccessControl>
								<AccessControl target={"HR:HRSETTINGS"} renderNoAccess={null}>
									<MenuItem
										icon={<span className="material-icons">settings</span>}
									>
										HR Settings
										<Link to="/hr/settings" />
									</MenuItem>
								</AccessControl>
								<AccessControl target={"HR:ADMIN"} renderNoAccess={null}>
									<MenuItem
										icon={<span className="material-icons">summarize</span>}
									>
										Reports
										<Link to="/hr/reports" />
									</MenuItem>
								</AccessControl>
							</SubMenu>
						)}
						{/********************************************IT Operations***************************************************/}
						{(shouldAllowAccess("PortalAdmin") ||
							shouldAllowAccess("IT:ITOperator")) && (
							<SubMenu
								title="IT Operations"
								icon={<span className="material-icons">storage</span>}
							>
								<MenuItem
									icon={<span className="material-icons">history</span>}
								>
									Portal Sessions
									<Link to="/it/portal-sessions" />
								</MenuItem>
								{(shouldAllowAccess("IT:PositiveResponse") ||
									shouldAllowAccess("PortalAdmin")) && (
									<MenuItem icon={<span className="material-icons">sync</span>}>
										Positive Responses
										<Link to="/it/positive-responses" />
									</MenuItem>
								)}
							</SubMenu>
						)}
						{/********************************************Company Administration***************************************************/}
						{/* {shouldAllowAccess("PortalAdmin") &&
                            < SubMenu title="Company Administration" icon={<span className="material-icons">business</span>}>
                                <AccessControl target={"PortalAdmin"} renderNoAccess={null}>
                                    <MenuItem icon={<span className="material-icons">supervised_user_circle</span>}>
                                        Customer Management
                                        <Link to="/company-administration/customer-management" />
                                    </MenuItem>
                                </AccessControl>
                            </SubMenu>} */}
						{/********************************************Company Operations***************************************************/}
						{shouldAllowAccess("COOP") && (
							<SubMenu
								title="Company Operations"
								icon={<span className="material-icons">assessment</span>}
							>
								<AccessControl target="COOP:TICKETSEARCH" renderNoAccess={null}>
									<MenuItem
										icon={
											<span className="material-icons">
												confirmation_number
											</span>
										}
									>
										Ticket Search
										<Link to="/coop/ticket-search" />
									</MenuItem>
								</AccessControl>
								<AccessControl target="COOP:TIMEADMIN" renderNoAccess={null}>
									<MenuItem
										icon={
											<span className="material-icons">pending_actions</span>
										}
									>
										Time Administration
										<Link to="/hr/time-administration" />
									</MenuItem>
								</AccessControl>
								{
									<AccessControl target="COOP:FORMS" renderNoAccess={null}>
										<MenuItem
											icon={
												<span className="material-icons">dynamic_feed</span>
											}
										>
											Dynamic Forms
											<Link to="/coop/dynamic-forms" />
										</MenuItem>
									</AccessControl>
								}
								<AccessControl
									target="PORTAL:EMPLOYEE-LIST-VIEWER"
									renderNoAccess={null}
								>
									<MenuItem
										icon={<span className="material-icons">people</span>}
									>
										Employees
										<Link to="/coop/employees" />
									</MenuItem>
								</AccessControl>
								<AccessControl target="COOP:PTO" renderNoAccess={null}>
									<MenuItem
										icon={<span className="material-icons">access_time</span>}
									>
										PTO Administration
										<Link to="/coop/pto" />
									</MenuItem>
								</AccessControl>
								<AccessControl target="COOP:DAILYREVIEW" renderNoAccess={null}>
									<MenuItem
										icon={<span className="material-icons">today</span>}
									>
										Daily Review
										<Link to="/coop/daily-review" />
									</MenuItem>
								</AccessControl>
								<AccessControl
									target="COOP:POSITIVERESPONSECODE"
									renderNoAccess={null}
								>
									<MenuItem
										icon={<span className="material-icons">add_comment</span>}
									>
										Positive Response Codes
										<Link to="/coop/positive-response-codes" />
									</MenuItem>
								</AccessControl>
							</SubMenu>
						)}
						{/**************************************************Portal / API***************************************************/}
						{/* {shouldAllowAccess("PortalAdmin") &&
                            <SubMenu title="Portal / API" icon={<span className="material-icons">cloud</span>}>
                                <MenuItem icon={<span className="material-icons">app_registration</span>}>
                                    Register
                                    <Link to="/registered-clients" />
                                </MenuItem>
                                <MenuItem icon={<span className="material-icons">new_releases</span>}>
                                    Create New Release
                                    <Link to="/create-release" />
                                </MenuItem>
                                <MenuItem icon={<span className="material-icons">visibility</span>}>
                                    View Releases
                                    <Link to="/releases" />
                                </MenuItem>
                            </SubMenu>} */}
						{/**************************************************Admin Portal***************************************************/}
						{shouldAllowAccess("PortalAdmin") && (
							<SubMenu
								title="Portal Admin"
								icon={<span className="material-icons">build</span>}
							>
								<MenuItem
									icon={
										<span className="material-icons">admin_panel_settings</span>
									}
								>
									Add/Remove Roles
									<Link to="/role-management" />
								</MenuItem>
								{/* <MenuItem icon={<span className="material-icons">card_membership</span>}>
                                        Registered Clients
                                        <Link to="/registered-clients" />
                                    </MenuItem> */}
								<MenuItem
									icon={<span className="material-icons">toggle_on</span>}
								>
									Endpoint Security
									<Link to="/endpoint-security" />
								</MenuItem>
								<MenuItem
									icon={
										<span className="material-icons">person_add_alt_1</span>
									}
								>
									Client Management
									<Link to="/it/client-management" />
								</MenuItem>
							</SubMenu>
						)}
						{/******************************************************Fleet*******************************************************/}
						{(shouldAllowAccess("FLEET:USER") ||
							shouldAllowAccess("FLEET:MA")) && (
							<SubMenu
								title="Fleet"
								className={actionablePendingClass}
								icon={<span className="material-icons">commute</span>}
							>
								<MenuItem icon={<span className="material-icons">garage</span>}>
									Vehicles
									<Link to="/fleet" />
								</MenuItem>
								{shouldAllowAccess("FLEET:LEASEUSER") &&
									this.props.features?.LeaseTracker && (
										<SubMenu
											title="Lease Tracking"
											className={actionablePendingClass}
											icon={
												<span className="material-icons">auto_stories</span>
											}
										>
											<MenuItem
												icon={<span className="material-icons">summarize</span>}
											>
												Summary
												<Link to="/fleet/lease-tracking#summary" />
											</MenuItem>
											<MenuItem
												icon={
													<span className="material-icons">assignment</span>
												}
											>
												Monthly Entry
												<Link to="/fleet/lease-tracking#monthly-entry" />
											</MenuItem>
											<MenuItem
												className="sm2-badged-item"
												icon={
													<span className="material-icons">price_check</span>
												}
												suffix={
													showActionableBadge ? (
														<span className="sm2-count">
															{actionableRequestCount}
															<span className="sm2-sr-only">
																{" "}
																requests awaiting your approval
															</span>
														</span>
													) : undefined
												}
											>
												Requests Manager
												<Link to="/fleet/lease-tracking#requests" />
											</MenuItem>
											<MenuItem
												icon={<span className="material-icons">upload_file</span>}
											>
												Import Leases
												<Link to="/fleet/lease-tracking#import" />
											</MenuItem>
										</SubMenu>
									)}
							</SubMenu>
						)}
						{shouldAllowAccess("Fleet:VehicleIncidents") && (
							<div>
								{this.state.collapsed && (
									<OverlayTrigger
										delay={{ show: 0, hide: 0 }}
										placement="right"
										overlay={sm2Tooltip("Vehicle Incidents")}
									>
										<MenuItem
											icon={<span className="material-icons">car_crash</span>}
										>
											Vehicle Incidents
											<Link to="/vehicle-incidents" />
										</MenuItem>
									</OverlayTrigger>
								)}
								{!this.state.collapsed && (
									<MenuItem
										icon={<span className="material-icons">car_crash</span>}
									>
										Vehicle Incidents
										<Link to="/vehicle-incidents" />
									</MenuItem>
								)}
							</div>
						)}
						{/******************************************************Invoice*******************************************************/}
						{shouldAllowAccess("CSS") && (
							<SubMenu
								title="CSS"
								icon={<span className="material-icons">support_agent</span>}
							>
								{shouldAllowAccess("CSS:ADMIN") && (
									<>
										<MenuItem
											icon={
												<span className="material-icons">account_balance</span>
											}
										>
											Billing Group Pricing
											<Link to="/css/billing-group-pricing" />
										</MenuItem>

										<MenuItem
											icon={
												<span className="material-icons">
													transfer_within_a_station
												</span>
											}
										>
											Footage Restricted Maintenance
											<Link to="/css/footage-restricted-locate-maintenance" />
										</MenuItem>
										<MenuItem
											icon={<span className="material-icons">source</span>}
										>
											Revenue Report
											<Link to="/css/revenue-report" />
										</MenuItem>
									</>
								)}
								{shouldAllowAccess("IP") && (
									<div>
										{this.state.collapsed && (
											<OverlayTrigger
												delay={{ show: 0, hide: 0 }}
												placement="right"
												overlay={sm2Tooltip("Invoice")}
											>
												<MenuItem
													icon={
														<span className="material-icons">price_check</span>
													}
												>
													Invoice Progress
													<Link to="/invoice" />
												</MenuItem>
											</OverlayTrigger>
										)}
										{!this.state.collapsed && (
											<MenuItem
												icon={
													<span className="material-icons">price_check</span>
												}
											>
												Invoice Progress
												<Link to="/invoice" />
											</MenuItem>
										)}
									</div>
								)}
							</SubMenu>
						)}
						{/******************************************************Settings*******************************************************/}
						{this.shouldShowSettings() && (
							<SubMenu
								className="SM2SettingsMenuItem"
								title="Settings"
								icon={<span className="material-icons">settings</span>}
							>
								{/* <MenuItem icon={<span className="material-icons">assessment</span>}>
                                Company Operations
                                <Link to="/coop-settings" />
                            </MenuItem> */}
								{shouldAllowAccess("CSS") && (
									<SubMenu
										title="CSS"
										icon={
											<span className="material-icons">contact_support</span>
										}
									>
										{shouldAllowAccess("CSS:ADMIN") && (
											<>
												<MenuItem
													icon={<span className="material-icons">gavel</span>}
												>
													Contract Maintenance
													<Link to="/css/contract-maintenance" />
												</MenuItem>
												<MenuItem
													icon={<span className="material-icons">source</span>}
												>
													Member Code Maintenance
													<Link to="/css/member-code-maintenance" />
												</MenuItem>
											</>
										)}
									</SubMenu>
								)}
								{shouldAllowAccess("FLEET:ADMIN") && (
									<SubMenu
										title="Fleet"
										icon={<span className="material-icons">commute</span>}
									>
										<MenuItem
											icon={
												<span className="material-icons">directions_car</span>
											}
										>
											Vehicle Make/Model
											<Link to="/fleet-settings/make-model" />
										</MenuItem>
									</SubMenu>
								)}
								{shouldAllowAccess("HR") && (
									<SubMenu
										title="Human Resources"
										icon={<span className="material-icons">people</span>}
									>
										{shouldAllowAccess("HR:ADMIN") && (
											<MenuItem
												icon={
													<span className="material-icons">access_time</span>
												}
											>
												PTO Plan Maintenance
												<Link to="/hr-settings/pto-plan-maintenance" />
											</MenuItem>
										)}
										{shouldAllowAccess("HR:ADMIN") && (
											<MenuItem
												icon={<span className="material-icons">list_alt</span>}
											>
												Job Title Maintenance
												<Link to="/hr-settings/job-title-maintenance" />
											</MenuItem>
										)}
									</SubMenu>
								)}
							</SubMenu>
						)}
						{(shouldAllowAccess("DispatchAssignments") ||
							shouldAllowAccess("DispatchRules")) && (
							<SubMenu
								title="Dispatch"
								icon={<span className="material-icons">local_shipping</span>}
							>
								{shouldAllowAccess("DispatchAssignments") && (
									<MenuItem
										icon={<span className="material-icons">next_week</span>}
									>
										Assignments
										<Link to={`/dispatch/assignments?period=current`} />
									</MenuItem>
								)}
								{shouldAllowAccess("DispatchRules") && (
									<MenuItem icon={<span className="material-icons">rule</span>}>
										Automation Rules
										<Link to={`/dispatch/rules?showInactive=false`} />
									</MenuItem>
								)}
							</SubMenu>
						)}
					</Menu>
					<div id="sm2-collapse-toggle" onClick={() => this.toggleCollapsed()}>
						{!this.state.collapsed && (
							<span className="material-icons" id="sm2-collapse-toggle-left">
								keyboard_double_arrow_left
							</span>
						)}
						{this.state.collapsed && this.state.screenWidth >= 1440 && (
							<span className="material-icons" id="sm2-collapse-toggle-right">
								keyboard_double_arrow_right
							</span>
						)}
					</div>
				</ProSidebar>
			</div>
		)
	}
}

const mapStateToProps = (state: any) => ({
	sideMenuOpen: state.menu.sideMenuOpen,
	homeProfitCenter: state.user.homeProfitCenter,
	features: state.features,
	actionableRequestCount: state.leaseApprovals.actionableRequestCount,
})

export default connect(mapStateToProps, {
	toggleAdmin,
	startActionableRequestsPoller,
})(SM2 as any)
